(() => {
  if (window.dartsrxScienceCardsReady) return;
  window.dartsrxScienceCardsReady = true;

  const cardSelector = '[data-dartsrx-science-card]';
  const toggleSelector = '[data-dartsrx-science-toggle]';
  const closeSelector = '[data-dartsrx-science-close]';

  const setCardState = (card, isFlipped) => {
    if (!card) return;

    const toggle = card.querySelector(toggleSelector);
    const back = card.querySelector('.dartsrx-science-card__back');

    card.classList.toggle('is-flipped', isFlipped);

    if (toggle) {
      toggle.setAttribute('aria-expanded', isFlipped ? 'true' : 'false');
    }

    if (back) {
      back.setAttribute('aria-hidden', isFlipped ? 'false' : 'true');
    }
  };

  const closeSiblingCards = (card) => {
    const grid = card.closest('.dartsrx-science-page__grid');
    if (!grid) return;

    grid.querySelectorAll(`${cardSelector}.is-flipped`).forEach((openCard) => {
      if (openCard !== card) {
        setCardState(openCard, false);
      }
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(toggleSelector);

    if (toggle) {
      const card = toggle.closest(cardSelector);
      if (!card) return;

      const shouldOpen = !card.classList.contains('is-flipped');
      closeSiblingCards(card);
      setCardState(card, shouldOpen);
      return;
    }

    const close = event.target.closest(closeSelector);

    if (close) {
      const card = close.closest(cardSelector);
      if (!card) return;

      setCardState(card, false);
      const toggleButton = card.querySelector(toggleSelector);
      if (toggleButton) {
        toggleButton.focus({ preventScroll: true });
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${cardSelector}.is-flipped`).forEach((card) => {
      setCardState(card, false);
    });
  });
})();
